import { RemoteMongoCollection } from 'mongodb-stitch-browser-sdk';
  
import { Text, color, setScoreColor } from './common';
import React, { useState, useEffect } from 'react';
import { idea, option } from './common';

import { 
    PROBLEM_FREQUENCY, 
    MARKET_GROWTH, 
    PRODUCT_COST, 
    POPULARITY, 
    MANDATORY, 
    URGENCY, 
} from './common';


interface iSelect {
    options: option[], 
    label: string,
    value?: any,
    select(option: any): void
}

const Select = ({ options, label, value=null, select }: iSelect) => <div className="field">
    <label className="label"> { label } </label>
    <div className="control">
        <div className="select">
            <select onChange={({target: {value}}) => select(value)} value={value}>
                {   
                    options.map((option) => typeof(option) === 'object' && 'value' in option
                        ?   <option value={option.value}> { option.text } </option>
                        :   <option value={option}> { option } </option>
                    )
                }
            </select>
        </div>
    </div>
</div>


interface iIdeaResults {
    popularity: string;
    market: string;
    frequency: string;
    cost: string;
    urgency: string;
    mandatory: string;
}

/** @organism IdeaModal: */
type IdeaResult = { label: string; score?: any; color?: color }
interface iIdeaDetail { 
    idea: idea;
    collection?: RemoteMongoCollection<any>;
    onClose():void
}

export const IdeaDetail = ({idea, collection, onClose}: iIdeaDetail) => {
    const [popularity, setPopularity] = useState<string | null>(null)
    const [market, setMarket] = useState<string | null>(null)
    const [frequency, setFrequency] = useState<string | null>(null)
    const [cost, setCost] = useState<string | null>(null)
    const [urgency, setUrgency] = useState<string | null>(null)
    const [mandatory, setMandatory] = useState<string | null>(null)

    const [viewResults, setViewResults] = useState<boolean>(!collection || false)
    const [, setResults] = useState<IdeaResult[]>([])

    const rateIdea = async() => {
        const newDoc = { idea: idea.name, popularity, market, frequency, cost, urgency, mandatory }
        if(collection) await collection.insertOne(newDoc).catch(console.log)
    }

    useEffect(() => { 
        const fetchResults = async() => {
            if(collection){
                const docs = await collection.find({}).asArray().catch(console.log)  as iIdeaResults[];
    
                const popularityResults = Object.entries(docs.reduce((d, {popularity: i}: {popularity : string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                const marketResults = Object.entries(docs.reduce((d, {market: i}: {market : string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                const frequencyResults = Object.entries(docs.reduce((d, {frequency: i}: {frequency : string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                const costResults = Object.entries(docs.reduce((d, {cost: i}: {cost : string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                const urgencyResults = Object.entries(docs.reduce((d, {urgency: i}: {urgency : string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                const mandatoryResults = Object.entries(docs.reduce((d, {mandatory: i}: {mandatory: string}) => 
                    ({...d, [i]: i in d ? d[i] + 1 : 1}), {} as {[key: string]: number}
                )).reduce((d, i) => i[1] > d.count ? {value:i[0], count:i[1]}: d, {value: '', count: 0})
    
                setResults([
                    {label: 'Potential Users', score: popularityResults.value},
                    {label: 'Market Growth', score: marketResults.value},
                    {label: 'Problem Frequency', score: frequencyResults.value},
                    {label: 'Possible Cost', score: costResults.value},
                    {label: 'Is the problem Urgent', score: urgencyResults.value},
                    {label: 'Is it mandatory to be Solved', score: mandatoryResults.value}
                ])
            }
        }

        fetchResults() 
    }, [collection])
     
    const RateIdea = <>
        <Select {...POPULARITY} value={popularity} select={(e) => setPopularity(e)}/>
        <Select {...MARKET_GROWTH} value={market} select={(e) => setMarket(e)}/>
        <Select {...PROBLEM_FREQUENCY} value={frequency} select={(e) => setFrequency(e)}/>
        <Select {...PRODUCT_COST} value={cost} select={(e) => setCost(e)}/>
        <Select {...URGENCY} value={urgency} select={(e) => setUrgency(e)}/>
        <Select {...MANDATORY} value={mandatory} select={(e) => setMandatory(e)}/>
    </>

    const popularityResults = <>
            { POPULARITY.text }
            <strong style={{color:'#3298dc'}}> 
                { POPULARITY.options.find(({ value }) => value === idea.results[0].popularity)?.text }
            </strong>
    </>

    const marketResults = <>
            { MARKET_GROWTH.text }
            <strong style={{color:'#3298dc'}}> 
                { MARKET_GROWTH.options.find(({ value }) => value === idea.results[0].market)?.text }
            </strong>
    </>

    const frequencyResults = <>
            { PROBLEM_FREQUENCY.text }
            <strong style={{color:'#3298dc'}}> 
                { PROBLEM_FREQUENCY.options.find(({ value }) => value === idea.results[0].frequency)?.text }
            </strong>
    </>

    const costResults = <>
            { PRODUCT_COST.text }
            <strong style={{color:'#3298dc'}}> 
                { PRODUCT_COST.options.find(({ value }) => value === idea.results[0].cost)?.text }
            </strong>
    </>

    const urgencyResults = <>
            { URGENCY.text }
            <strong style={{color:'#3298dc'}}> 
                { URGENCY.options.find(({ value }) => value === idea.results[0].urgency)?.text }
            </strong>
    </>

    const mandatoryResults = <>
            { MANDATORY.text }
            <strong style={{color:'#3298dc'}}> 
                { MANDATORY.options.find(({ value }) => value === idea.results[0].mandatory)?.text }
            </strong>
    </>

    const Results = <>
        <div className="divider is-info"> Idea's Value </div>
            <div className="columns">
                <div className="column">
                    <Text content={ popularityResults } size={6} alignment={'centered'}/>
                </div>
                <div className="column">
                    <Text content={ costResults } size={6} alignment={'centered'}/>
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <Text content={ marketResults } size={6} alignment={'centered'}/>
                </div>
                <div className="column">
                    <Text content={ urgencyResults } size={6} alignment={'centered'}/>
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <Text content={ frequencyResults } size={6} alignment={'centered'}/>
                </div>
                <div className="column">
                    <Text content={ mandatoryResults } size={6} alignment={'centered'}/>
                </div>
            </div>
        <Text 
            content={`Score: ${idea.score}%`} 
            alignment={'centered'} 
            isTitle size={3} 
            color={setScoreColor(idea.score)}
        />
    </>


    return <div className="modal is-active">
        <div className="modal-background"></div>
            <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">
                    <strong>
                        {
                            idea.url
                                ?   
                                    <a 
                                        href={ idea.url } 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    > { idea.name } </a>
                                :   idea.name
                        }
                    </strong>
                </p>
                <button className="delete" aria-label="close" onClick={onClose}/>
            </header>

            <section className="modal-card-body">
                { false ? <Text content={idea.pitch} isSubtitile/> : null }
                <Text content={idea.description} />
                { viewResults ? Results : RateIdea }
            </section>

                <footer className="modal-card-foot">
                    {
                        collection
                            ?
                                <button
                                    className="button"
                                    onClick={() => setViewResults(!viewResults)}
                                >View Results</button>
                            :   viewResults
                                ?   null
                                : 
                                    <button 
                                        className="button is-success" 
                                        onClick={rateIdea}
                                    >Submit</button>
                    }

                    <button 
                        id="close-modal" 
                        className="button" 
                        onClick={onClose}
                        style={{marginLeft:'auto'}}
                    >Close Modal</button>
                </footer>

        </div>
    </div>
}
